import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const TopBarLanguageSelector = () => {
	const { i18n } = useTranslation();
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);
	const [currentLang, setCurrentLang] = useState('en');

	// Update current language when i18n language changes
	useEffect(() => {
		setCurrentLang(i18n.language || 'en');
	}, [i18n.language]);

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
		setCurrentLang(lng);
		setIsOpen(false);
	};

	const languages = [
		{ code: 'en', label: '🇬🇧 EN' },
		{ code: 'es', label: '🇪🇦 ES' },
		{ code: 'fr', label: '🇫🇷 FR' },
	];

	const currentLanguage = languages.find((lang) => lang.code === currentLang) || languages[0];

	return (
		<div className='relative' ref={dropdownRef}>
			<button
				className='flex items-center space-x-1 px-3 py-1.5 text-white font-medium rounded-full bg-opacity-20 bg-white backdrop-blur-sm hover:bg-opacity-30 transition-all duration-300 shadow-sm'
				onClick={() => setIsOpen(!isOpen)}
			>
				<span>{currentLanguage.label}</span>
				<svg
					className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
					fill='none'
					stroke='currentColor'
					viewBox='0 0 24 24'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M19 9l-7 7-7-7'></path>
				</svg>
			</button>

			{isOpen && (
				<div className='absolute right-0 mt-2 w-24 rounded-lg shadow-lg py-1 bg-white bg-opacity-20 backdrop-blur-md border border-white border-opacity-20 overflow-hidden z-20 animate-fadeIn'>
					{languages.map((lang) => (
						<button
							key={lang.code}
							className={`block w-full text-left px-4 py-2 text-sm hover:bg-white hover:bg-opacity-20 transition-colors ${
								currentLang === lang.code ? 'font-bold' : ''
							}`}
							onClick={() => changeLanguage(lang.code)}
						>
							{lang.label}
						</button>
					))}
				</div>
			)}
		</div>
	);
};

export default TopBarLanguageSelector;
